const articleHasAnchor = $('.js-articleHasAnchor')
const h2 = articleHasAnchor.find('h2')

// на проекте уже есть обработчик для скролла к элементу js-scrollToElem, по этому создаю js-scrollToElem
function createAnchorlink(title, href) {
  return `
    <a class="anchor js-scrollToElem js-offsetMedium" href="#${href}">
      <div class="anchor-title">${title}</div>
      <div class="anchor-icon">
        <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.56105 10.9275C1.27078 10.6353 0.798568 10.6337 0.506343 10.924C0.214117 11.2142 0.212533 11.6864 0.502804 11.9787L9.01059 20.5437L9.53971 21.0764L10.0688 20.5437L18.5766 11.9787C18.8669 11.6864 18.8653 11.2142 18.5731 10.924C18.2808 10.6337 17.8086 10.6353 17.5184 10.9275L10.2855 18.209L10.2855 0.745819C10.2855 0.333929 9.95163 2.67029e-05 9.53974 2.67029e-05C9.12785 2.67029e-05 8.79395 0.333929 8.79395 0.745819L8.79395 18.2091L1.56105 10.9275Z" fill="currentColor"/>
        </svg>      
      </div>
    </a>
  `
}

if (articleHasAnchor.length > 0 && h2.length > 0) {
  h2.each((index, el) => {
    const elem = $(el)

    elem.attr('id', `anchor-${index}`)

    articleHasAnchor.before(createAnchorlink(elem.text(), `anchor-${index}`))
  })
}
